import styled, { css } from "styled-components";
import media from "constants/media";

export const Container = styled.div`
    position: relative;
`;

export const InputWrapper = styled.div`
    margin-top: ${props => (props.isInModal ? "0" : "17px")};

    ${props =>
        props.isInModal &&
        css`
            input {
                border-radius: 0;
            }
        `}

    ${media.mdUp`
        margin-top: 10px;
    `}
`;

export const SuggestionsList = styled.ul`
    position: absolute;
    top: 81px;
    z-index: 9;

    width: ${({ cityOnly }) => (cityOnly ? "calc(100% + 40px)" : "100%")};
    margin: ${({ cityOnly }) => (cityOnly ? "0 -20px" : "0")};
    padding: ${({ cityOnly }) => (cityOnly ? "10px 0px" : "0")};

    overflow: hidden;

    list-style-type: none;
    background-color: var(--color-white);

    margin-block-start: 0;
    padding-inline-start: 0;

    ${media.mdUp`
        top: 85px;
        margin: 0;

        width: 100%;

        box-shadow: 3px 3px 7px 0 rgba(0,23,75,0.05);
        padding: ${({ cityOnly }) => (cityOnly ? "0" : "0 20px")};

        border-color: var(--color-lightNight);
        border-style: solid;
        border-width: 0 1px 1px;

        ${props =>
            props.emptySuggestions &&
            css`
                box-shadow: -2px 2px 4px 0 rgba(2, 55, 48, 0.08);
            `}


    `}
`;

export const Placeholder = styled.li`
    padding: 10px;

    color: var(--color-darkNight);
    font-size: 15px;
    line-height: 25px;

    background-color: var(--color-white);

    border: 1px solid var(--color-darkNight);

    ${media.mdUp`
        padding: 0 0 15px;
        border: 0;
    `}
`;

export const Instructions = styled.div`
    padding: ${({ cityOnly }) => (cityOnly ? "15px 17px 0" : "13px 20px 0")};

    color: var(--color-red);

    ${media.lgUp`
        width: 100%;
    `}
`;
